export async function hashPinToSHA256(pin) {
  const encoder = new TextEncoder();
  const data = encoder.encode(pin);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashString = hashArray
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  return hashString;
}
